export default __webpack_public_path__ + "navigation-examples-route-lines-styling-thumbnail-960-1df3b6da3ff012159ba1aa453f75379e.webp";